export const RESERVATION_SENSITIVE_DATA_PERMISSION_KEY = 'reservationSensitiveData'

const DEFAULT_ALLOWED_ROLES = ['ADMIN', 'MANAGER'] as const

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

/**
 * Resolves the role-level toggle controlling guest identity, contact details,
 * financials, reservation identifiers, notes, custom fields, chat, and access
 * links. An explicit role/custom-role value wins over the built-in defaults.
 */
export function canViewReservationSensitiveData(permissions: unknown, role: string): boolean {
  const config = isRecord(permissions) ? permissions : null
  const explicitValue = config?.[RESERVATION_SENSITIVE_DATA_PERMISSION_KEY]
  if (typeof explicitValue === 'boolean') {
    return explicitValue
  }

  return DEFAULT_ALLOWED_ROLES.some((allowedRole) => allowedRole === role)
}
